import { render, staticRenderFns } from "./NavSearch.vue?vue&type=template&id=09a23aaa&"
import script from "./NavSearch.vue?vue&type=script&lang=js&"
export * from "./NavSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports